import { Directive, HostListener, Input, Renderer2, ElementRef, OnChanges } from "@angular/core";

@Directive({
  selector: "[prevent-click-event]"
})
export class PreventClickEvent implements OnChanges {
  @Input('prevent-click-event') preventClick: boolean;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges() {
    if (this.preventClick) {
      this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'true');
    } else {
      this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
    }
  }

  @HostListener("click", ["$event"])
  public onClick(event: any): void {
    if (this.preventClick) {
      if (!event) event = window.event;
      event.preventDefault();
      if (event.stopPropagation) {
        event.stopPropagation();
      } else {
        event.cancelBubble = true;
      }
    }
  }
}
